import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';

import { SchoolDataComponent } from './school-data.component';
import { SchoolDataService } from '../../../../services/school-data/school-data.service';
import { ShiftService } from '../../../../services/shifts/shift.service';
import { EmployeeService } from '../../../../services/employee/employee.service';
import { Md2Module } from 'md2';

const routes = [
    {
        path: 'pages/management/schooldata',
        component: SchoolDataComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SCHOOLDATA',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    }
];

@NgModule({
    declarations: [
        SchoolDataComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        Md2Module,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
    ],
    providers: [
        SchoolDataService,
        ShiftService,
        EmployeeService
    ],
    entryComponents: [
    ]
})

export class SchoolDataModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/school-data/school-data.module.ts